/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            if (window.SLIDECART_STATE().settings.enabled) {
                setTimeout(function () {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                }, 200);
            }
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

/*********
 Custom Play Button
 *********/
document.querySelectorAll('div.playButton').forEach(button => {
    const video = button?.querySelector('video');
    video.addEventListener('play', function () {
        button.classList.remove('playButton');
    })
})

// Handle quantity increase
document.querySelectorAll(".cartqua button.js-qty__adjust.js-qty__adjust--plus, .js-qty__adjust--plus").forEach(button => {
    button.addEventListener("click", function () {
        const input = this.parentElement.querySelector("input");
        let currentQty = parseInt(input.value);
        const originalContent = this.innerHTML;
        this.innerHTML = '<span class="loading-spinner"></span>';
        let newQty = currentQty + 1;
        input.value = newQty;

        let variantId = parseInt(this.getAttribute("data-varid"));

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `quantity=${newQty}&id=${variantId}`
        })
            .then(response => response.json())
            .then(cart => {
                location.reload();
            });
    });
});

// Handle quantity decrease
document.querySelectorAll(".cartqua button.js-qty__adjust.js-qty__adjust--minus, .js-qty__adjust--minus").forEach(button => {
    button.addEventListener("click", function () {
        const input = this.parentElement.querySelector("input");
        let currentQty = parseInt(input.value);
        const originalContent = this.innerHTML;
        this.innerHTML = '<span class="loading-spinner"></span>';

        if (currentQty < 1) return;

        let newQty = currentQty - 1;
        input.value = newQty;

        let variantId = parseInt(this.getAttribute("data-varid"));
        console.log(variantId);

        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: `quantity=${newQty}&id=${variantId}`
        })
            .then(response => response.json())
            .then(cart => {
                location.reload();
            });
    });
});